import axios from 'axios';

const apiUrl = `API_URL`;
const normalizedApiUrl = /^https?:\/\//.test(apiUrl) ? apiUrl : `//${apiUrl}`;

export default axios.create({
    baseURL: `${normalizedApiUrl.replace(/\/$/, '')}/api/`,
    xsrfCookieName: 'csrftoken',
    xsrfHeaderName: 'X-CSRFToken',
});
